import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

function RouteGuard({ children }) {
    const { pathname } = useLocation();
    const router = useNavigate();
    const user = useSelector(s => s.generalReducer.user)

    const needsAuth = ['/candidate-detail'].includes(pathname) && !user?.id;
    const needsGuest = ['/login'].includes(pathname) && !!user?.id;

    useEffect(() => {
        if (needsAuth) {
            router('/login');
        } else if (needsGuest) {
            router('/candidate-detail');
        }
    }, [pathname, user, needsAuth, needsGuest, router]);

    // Only blank the shell while redirecting protected/guest-only routes
    if (needsAuth || needsGuest) {
        return null;
    }

    return <>{children}</>;
};

export default RouteGuard;
